
(()=>{
  const root=document.querySelector('[data-mnq]');
  if(!root)return;

  const state={project_type:'',size:'',use:'',budgetIndex:-1,budgetLabel:'',details:''};

  let startingPrices={},copy={};
  try{startingPrices=JSON.parse(root.querySelector('[data-mnq-pricing]').textContent);copy=JSON.parse(root.querySelector('[data-mnq-copy]').textContent);}catch{}
  const formatPrice=value=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:copy.currency||'USD',minimumFractionDigits:Number.isInteger(value)?0:2,maximumFractionDigits:2}).format(value);
  function refreshStartingPrices(){
    const mode=['Logo neon','Business sign'].includes(state.project_type)?'logo':'words';
    const place=state.use==='Outdoor'?'Outdoor':'Indoor';
    for(const button of root.querySelectorAll('[data-field="size"] button[data-value$="inches"]')){
      const width=parseInt(button.dataset.value,10),price=startingPrices[mode]?.[place]?.[width];
      const label=button.querySelector('span');
      if(!Number.isFinite(price)){if(label)label.textContent=copy.seePrice;continue;}
      if(label)label.textContent=copy.fromPrice.replace('__PRICE__',formatPrice(price));
      const tier=price<500?0:price<750?1:price<1000?2:3;
      button.dataset.budgetIndex=String(tier);
      button.dataset.budgetLabel=['Under $500','$500 – $750','$750 – $1,000','$1,000+'][tier];
      if(button.classList.contains('is-selected')){state.budgetIndex=tier;state.budgetLabel=button.dataset.budgetLabel;}
    }
  }
  const overWrap=root.querySelector('[data-oversized-wrap]');
  const overInput=root.querySelector('[data-oversized-input]');
  const contactName=root.querySelector('[data-contact-name]');
  const contactEmail=root.querySelector('[data-contact-email]');
  const contactPhone=root.querySelector('[data-contact-phone]');
  const details=root.querySelector('[data-details]');
  const submitError=root.querySelector('[data-submit-error]');
  const submitState=root.querySelector('[data-submit-state]');
  const submitLoader=root.querySelector('[data-submit-loader]');
  const submitSuccess=root.querySelector('[data-submit-success]');
  const submitButton=root.querySelector('[data-submit-quote]');
  let quoteSending=false,directPending=null;
  const submitLabel=submitButton.textContent;
  const logoUpload=root.querySelector('[data-logo-upload]');
  const locationUpload=root.querySelector('[data-location-upload]');
  const logoStatus=root.querySelector('[data-logo-status]');
  const locationStatus=root.querySelector('[data-location-status]');
  const artPreview=root.querySelector('[data-art-preview]');
  const artPreviewImg=root.querySelector('[data-art-preview-img]');
  const artFile=root.querySelector('[data-art-file]');
  const preflightBox=root.querySelector('[data-preflight]');
  const preflightTitle=root.querySelector('[data-preflight-title]');
  const preflightMessage=root.querySelector('[data-preflight-message]');
  let artworkPreflight={status:'',message:''};
  const startedAt=Date.now();

  const honeypot=root.querySelector("[data-quote-honeypot]");
  refreshStartingPrices();
  syncArtworkRequirement();

  function promptContinue(button,enabled){
    if(!button)return;
    const wasDisabled=button.disabled;
    button.disabled=!enabled;
    if(enabled&&wasDisabled){
      button.classList.remove('mnq-ready-nudge');
      void button.offsetWidth;
      button.classList.add('mnq-ready-nudge');
      if(navigator.vibrate)navigator.vibrate(28);
      setTimeout(()=>button.classList.remove('mnq-ready-nudge'),1700);
    }
  }

  function updateFlow(n){
    root.querySelectorAll('[data-flow-dot]').forEach(el=>{const number=Number(el.dataset.flowDot);el.classList.toggle('is-complete',number<n);if(number===n)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');});
    const count=root.querySelector('[data-flow-count]');if(count)count.textContent=count.dataset.countTemplate.replace('__STEP__',String(n));
  }
  function showStep(n){
    updateFlow(Number(n));
    root.querySelectorAll('[data-step]').forEach(el=>el.classList.toggle('is-active',el.dataset.step===String(n)));
    root.querySelectorAll('[data-dot]').forEach(el=>el.classList.toggle('is-active',Number(el.dataset.dot)<=Number(n)));
    if(Number(n)===3){
      root.querySelector('[data-summary]').innerHTML=[
        state.project_type,
        state.size==='Oversized'?(overInput.value+' inches'):state.size,
        state.use
      ].filter(Boolean).map(v=>'<span>'+v+'</span>').join('');
      showFinal('contact');
      syncContactNext();
    }
  }

  function showFinal(name){
    updateFlow({contact:3,details:4,artwork:5}[name]||3);
    root.querySelectorAll('[data-final-screen]').forEach(el=>el.classList.toggle('is-active',el.dataset.finalScreen===name));
    if(name==='artwork')syncArtworkRequirement();
    root.querySelector('[data-step="3"]')?.scrollIntoView({behavior:'smooth',block:'start'});
  }

  function sizeValid(){return state.size&&state.size!=='Oversized'||(state.size==='Oversized'&&Number(overInput.value)>60)}
  function step2Valid(){return sizeValid()&&!!state.use}

  root.querySelectorAll('[data-field]').forEach(group=>{
    group.querySelectorAll('button').forEach(btn=>btn.addEventListener('click',()=>{
      group.querySelectorAll('button').forEach(b=>b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      state[group.dataset.field]=btn.dataset.value;
      if(group.dataset.field==='project_type'||group.dataset.field==='use')refreshStartingPrices();
      if(group.dataset.field==='project_type'){
        syncArtworkRequirement();
        details.placeholder=state.project_type==='Text neon'?copy.textPlaceholder:copy.logoPlaceholder;
      }
      if(group.dataset.field==='size'){
        state.budgetIndex=Number(btn.dataset.budgetIndex);
        state.budgetLabel=btn.dataset.budgetLabel||'';
        const oversized=btn.hasAttribute('data-oversized');
        overWrap.hidden=!oversized;
        if(!oversized){
          overInput.value='';
          setTimeout(()=>{
            root.querySelector('[data-use-heading]')?.scrollIntoView({behavior:'smooth',block:'start'});
            setTimeout(()=>window.scrollBy({top:-120,behavior:'smooth'}),180);
          },100);
        }else setTimeout(()=>overInput.focus({preventScroll:true}),100);
      }
      if(group.dataset.field==='project_type')promptContinue(root.querySelector('[data-step="1"] .mnq-next'),true);
      promptContinue(root.querySelector('[data-step="2"] .mnq-next'),step2Valid());

    }));
  });

  overInput.addEventListener('input',()=>{
    promptContinue(root.querySelector('[data-step="2"] .mnq-next'),step2Valid());

    if(Number(overInput.value)>60)setTimeout(()=>root.querySelector('[data-use-heading]')?.scrollIntoView({behavior:'smooth',block:'start'}),120);
  });

  root.querySelectorAll('[data-next]').forEach(btn=>btn.addEventListener('click',()=>{if(!btn.disabled)showStep(btn.dataset.next)}));

  function contactValid(){
    const n=String(contactName.value||'').trim();
    const e=String(contactEmail.value||'').trim();
    const p=String(contactPhone.value||'').replace(/\D/g,'');
    return n.length>1&&/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e)&&p.length>=7;
  }
  function syncContactNext(){
    promptContinue(root.querySelector('[data-final-next="details"]'),contactValid());
  }
  [contactName,contactEmail,contactPhone].forEach(el=>{
    ['input','change','keyup','blur','focus'].forEach(evt=>{
      el.addEventListener(evt,()=>{syncContactNext();});
    });
  });
  let lastContactSnapshot='';
  setInterval(()=>{
    const snapshot=[contactName?.value||'',contactEmail?.value||'',contactPhone?.value||''].join('|');
    if(snapshot!==lastContactSnapshot){
      lastContactSnapshot=snapshot;
      syncContactNext();

    }
  },250);
  window.addEventListener('pageshow',()=>setTimeout(syncContactNext,120));
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)setTimeout(syncContactNext,120)});

  details.addEventListener('input',()=>{state.details=details.value;promptContinue(root.querySelector('[data-final-next="artwork"]'),details.value.trim().length>=3);});
  root.querySelectorAll('[data-suggestion]').forEach(btn=>btn.addEventListener('click',()=>{
    const current=details.value.trim();
    details.value=current?current+'\n'+btn.dataset.suggestion:btn.dataset.suggestion;
    details.dispatchEvent(new Event('input',{bubbles:true}));
    details.focus();
  }));

  root.querySelectorAll('[data-final-next]').forEach(btn=>btn.addEventListener('click',()=>{if(!btn.disabled){showFinal(btn.dataset.finalNext)}}));
  root.querySelectorAll('[data-final-back]').forEach(btn=>btn.addEventListener('click',()=>showFinal(btn.dataset.finalBack)));


  function artworkRequired(){return state.project_type!=='Text neon';}
  function uploadsValid(){return !artworkRequired()||!!logoUpload?.files?.length;}
  function syncArtworkRequirement(){
    const mandatory=artworkRequired();
    logoUpload.required=mandatory;
    const label=root.querySelector('[data-artwork-required-label]');
    const help=root.querySelector('[data-artwork-help]');
    if(label)label.textContent=mandatory?'*':copy.optional;
    if(help)help.textContent=mandatory?copy.requiredHelp:copy.optionalHelp;
    updateUploadUI();
  }
  async function createTextSignReference(){
    const canvas=document.createElement('canvas');canvas.width=1200;canvas.height=650;
    const ctx=canvas.getContext('2d');
    if(!ctx)throw Error(copy.textReferenceError);
    ctx.fillStyle='#fff';ctx.fillRect(0,0,1200,650);
    ctx.fillStyle='#101010';ctx.textAlign='center';ctx.textBaseline='middle';
    const lines=String(details.value||'').trim().split(/\n/).map(s=>s.trim()).filter(Boolean).slice(0,3);
    const count=lines.length||1,spacing=Math.min(145,490/count);
    const start=325-(count-1)*spacing/2;
    lines.forEach((line,i)=>{
      let font=94;
      ctx.font='bold '+font+'px Arial';
      while(font>30&&ctx.measureText(line).width>1110){font-=4;ctx.font='bold '+font+'px Arial';}
      ctx.fillText(line.slice(0,100),600,start+i*spacing,1110);
    });
    return new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?
      resolve(new File([blob],'customer-text-sign-reference.png',{type:'image/png'})):
      reject(Error(copy.textReferenceError)),'image/png'));
  }


  function setPreflight(status,title,message){
    artworkPreflight={status,message};
    if(!preflightBox)return;
    preflightBox.hidden=false;
    preflightBox.className='mnq-preflight '+(status==='ready'?'is-ready':status==='cleanup'?'is-cleanup':'is-review');
    preflightTitle.textContent=title;
    preflightMessage.textContent=message;
  }

  function previewRaster(file){
    return new Promise(resolve=>{
      const url=URL.createObjectURL(file);
      const img=new Image();
      img.onload=()=>{
        if(artPreviewImg){
          artPreviewImg.src=url;
          artPreview.hidden=false;
        }
        if(artFile)artFile.textContent=file.name;
        resolve({img,url});
      };
      img.onerror=()=>{URL.revokeObjectURL(url);resolve(null)};
      img.src=url;
    });
  }

  async function runArtworkPreflight(){
    const file=logoUpload?.files?.[0];
    if(preflightBox)preflightBox.hidden=true;
    artworkPreflight={status:'',message:''};
    if(artPreview)artPreview.hidden=true;
    if(!file)return;
    if(artFile)artFile.textContent=file.name;
    if(file.type.startsWith('image/'))try{await previewRaster(file);}catch{}
  }

  function updateUploadUI(){
    const logoFile=logoUpload?.files?.[0];
    const locationFile=locationUpload?.files?.[0];
    if(logoStatus)logoStatus.textContent=logoFile?'✓ '+logoFile.name:'No file selected';
    if(locationStatus)locationStatus.textContent=locationFile?'✓ '+locationFile.name:'No photo selected';
    logoUpload?.closest('.mnq-upload-card')?.classList.toggle('is-complete',!!logoFile);
    locationUpload?.closest('.mnq-upload-card')?.classList.toggle('is-complete',!!locationFile);
    promptContinue(root.querySelector('[data-submit-quote]'),uploadsValid());
  }


  logoUpload?.addEventListener('change',()=>{
    updateUploadUI();
    runArtworkPreflight();
  });
  locationUpload?.addEventListener('change',updateUploadUI);

  function showSendingState(){
    quoteSending=true;
    submitButton.disabled=true;
    submitButton.textContent='Sending…';
    submitError.hidden=true;
    submitState.hidden=false;
    submitLoader.hidden=false;
    submitSuccess.hidden=true;
    submitState.scrollIntoView({behavior:'smooth',block:'center'});
  }

  function showSuccessState(){
    if(!quoteSending)return;
    quoteSending=false;
    submitLoader.hidden=true;
    submitSuccess.hidden=false;
    submitButton.textContent='Quote sent ✓';
    submitButton.disabled=true;
    if(navigator.vibrate)navigator.vibrate([40,40,70]);
    const nextLink=submitSuccess.querySelector('[data-quote-next]');
    if(nextLink)setTimeout(()=>window.location.assign(nextLink.href),3000);
  }

  submitButton.addEventListener('click',async ()=>{
    if(quoteSending)return;
      if(!root.dataset.directIntakeUrl||!window.NeonFiveStepIntake){submitError.textContent=root.dataset.formLoadingError;submitError.hidden=false;return;}
      if(!contactValid()){showFinal('contact');return;}
      if(details.value.trim().length<3){showFinal('details');return;}
      if(!uploadsValid()){submitError.textContent=copy.uploadRequiredError;submitError.hidden=false;return;}
      quoteSending=true;submitButton.disabled=true;
      try{
        if(!directPending){
          const prefs=Object.fromEntries([...root.querySelectorAll('[data-mn-pref]')].map(input=>[input.dataset.mnPref,input.type==='checkbox'?(input.checked?'Yes':''):input.value]));
          const width=state.size==='Oversized'?Number(overInput.value):Number.parseFloat(state.size);
          const fields=window.NeonFiveStepIntake.fields(state,{name:contactName.value,email:contactEmail.value,phone:contactPhone.value,details:details.value},prefs,width);
          const original=logoUpload.files?.[0]||null;
          const artwork=original||await createTextSignReference();
          if(!original){
            fields.artworkProcess='Text sign reference generated; final font and layout need approval';
            fields.notes+='\nCustomer did not upload artwork. Text reference is only a starting draft; please select the closest appropriate font and email a final proof before production.';
          }
          directPending={requestId:crypto.randomUUID(),fields,artwork,location:locationUpload?.files?.[0]||null,website:String(honeypot?.value||'')};
        }
        if(directPending.website||Date.now()-startedAt<2500)throw Error('Please check your request and try again.');
        root.querySelectorAll('input,select,textarea,[data-next],[data-final-next],[data-final-back],[data-field] button,[data-suggestion]').forEach(control=>{if(control.dataset.directWasDisabled===undefined)control.dataset.directWasDisabled=String(control.disabled);control.disabled=true;});
        showSendingState();
        window.NeonFiveStepIntake.submit(root,directPending).then(result=>{
          let link=submitSuccess.querySelector('[data-request-link]');
          if(!link){link=document.createElement('a');link.dataset.requestLink='';link.className='mnq-success-next';link.textContent='Save your request link';link.target='_blank';link.rel='noopener';submitSuccess.prepend(link);}
          link.href=result.status_url;
          try{localStorage.setItem('miami-neons-last-request',result.status_url);}catch{}
          directPending=null;showSuccessState();
        }).catch(error=>{quoteSending=false;if(error.definitive){directPending=null;root.querySelectorAll('[data-direct-was-disabled]').forEach(control=>{control.disabled=control.dataset.directWasDisabled==='true';delete control.dataset.directWasDisabled;});}submitState.hidden=true;submitButton.textContent=directPending?'Retry save':submitLabel;submitButton.disabled=false;submitError.textContent=error.message;submitError.hidden=false;});
      }catch(error){quoteSending=false;submitButton.disabled=false;submitError.textContent=error.message;submitError.hidden=false;}
  });

})();

